export const ADMIN_BASE = "/admin-v2";
export const LEGACY_ADMIN_BASE = "/admin";
const API = "/api/internal_api/v1/admin";
const API_V2 = "/api/internal_api/v2/admin";

// PAGES
export const ADMINS_PATH = `/admins`;
export const FEATURES_PATH = `/features`;
export const LEVELS_PATH = `/levels`;
export const LEVEL_PATH = `/levels/:id`;
export const ROLES_PATH = `/roles`;
export const ROLE_NEW_QUEST_PATH = `/admin/roles/new-quest`;
export const ROLE_PATH = `/roles/:id`;
export const MISSION_NEW_MISSION_PATH = `/missions/new-mission`;
export const SJ_ADMIN_DEFAULT_PATH = "";
export const SJ_API_KEYS_PATH = `/api-keys/sj`;
export const VIRTUAL_DOJOS_PATH = `/virtual-dojos`;
export const TRY_US_LESSONS_PATH = `/try-us/lessons`;
export const ADMIN_LESSONS_PATH = `/lessons`;
export const ADMIN_EXPERIMENTS_PATH = `/experiments`;
export const SJ_ADMINS_PATH = `/sj-admins`;
export const AUDIENCES_PATH = `/audiences`;
export const REDIRECT_CONFIG_PATH = `/redirect-configuration`;
export const EMAILS_PATH = `/emails`;
export const SAML_APPROVE_PATH = `/saml_approve`;
export const IDP_LIST_PATH = `/idp-configurator`;

// NavBar Routing Constants

export const loginApp = "/login";
export const learnApp = "/";
export const userApp = "/profile";
export const kaApp = "/ka";
export const adminApp = "/admin";

export const UserAppRoutes = {
  route: `${userApp}`,
  name: "User",
  routes: {
    notes: { name: "Notes", route: `${userApp}/notes` },
    profile: { name: "Profile", route: `${userApp}` },
    certificates: { name: "Certificates", route: `${userApp}/certificates` },
    achievements: { name: "Achievements", route: `${userApp}/achievements` },
    assignments: { name: "Assignments", route: `${userApp}/assignments` },
    tournaments: { name: "Tournaments", route: `${userApp}/tournaments` },
    history: { name: "History", route: `${userApp}/history` },
    settings: { name: "Settings", route: `${userApp}/settings` },
  },
};

export const LearnAppRoutes = {
  name: "My Journey",
  route: `${learnApp}`,
  routes: {
    path: { name: "Path", route: `${learnApp}path/:pathId` },
    quest: { name: "Quest", route: `${learnApp}quest/:pathId` },
    level: { name: "Level", route: `${learnApp}levels/:levelId` },
    quests: { name: "Quests", route: `${learnApp}quests` },
    lesson: { name: "Lesson", route: `${learnApp}lesson/:lessonKey` },
    exercise: { name: "Exercise", route: `${learnApp}exercise/*` },
    catalog: { name: "Full Catalog", route: `${learnApp}catalog` },
    leaderboard: { name: "Leaderboard", route: `${learnApp}leaderboard` },
    achievements: { name: "Achievements", route: `${learnApp}achievements` },
    assessments: { name: "Assessments", route: `${learnApp}assess` },
    personalizedLessonAssignment: {
      name: "Personalized Assignment",
      route: `${learnApp}personalized-lesson-assignment`,
    },
    feedback: { name: "Feedback", route: `${learnApp}feedback` },
    tournaments: {
      name: "Tournaments",
      routes: {
        details: { name: "Details", route: `${learnApp}tournament/:tournamentId` },
        content: {
          name: "Tournament Content",
          route: `${learnApp}tournament/:tournamentId/:contentType/:contentId`,
        },
      },
    },
    scorm: { name: "SCORM Lesson", route: `${learnApp}scorm/lesson/:lessonKey` },
    scorm_redirect: { name: "SCORM Redirect", route: `${learnApp}scorm/:idpId/:lessonKey` },
    guest: {
      name: "Guest Access",
      route: `${learnApp}guest/:accessKey/:lessonKey`,
    },
    testConnection: { name: "Test Connection", route: `${learnApp}test-connection` },
    assessmentRedirect: {
      name: "Assessment Redirect",
      route: `${learnApp}assessment/:assignmentId`,
    },
    legacyBeltRedirect: {
      name: "Legacy Belt Redirect",
      route: `${learnApp}belts/:beltId/modules/:lessonId/lesson`,
    },
    legacyLessonRedirect: {
      name: "Legacy Lesson Redirect",
      route: `${learnApp}/modules/:lessonId/lesson`,
    },
    aspenChat: { name: "Aspen", route: `${learnApp}aspen` },
  },
};

// Commented out routes are legacy routes, kept here in case they are needed
export const AdminAppRoutes = {
  name: "Admin",
  route: `${adminApp}`,
  routes: {
    dashboard: { name: "Dashboard", route: `${adminApp}`, nav: true },
    reporting: {
      name: "Reporting",
      route: `${adminApp}/reports`,
      nav: true,
      navGroup: true,
      routes: {
        download: {
          name: "Downloadable Reports",
          route: `${adminApp}/reports/download`,
          nav: true,
        },
        progress: { name: "Progress", route: `${adminApp}/reports/progress`, nav: true },
        progressId: { name: "Progress Detail", route: `${adminApp}/reports/progress/:user_id` },
        usage: { name: "Usage", route: `${adminApp}/reports/usage`, nav: true },
        rankings: { name: "Rankings", route: `${adminApp}/reports/rankings`, nav: true },
        assignments: {
          name: "Assignments",
          route: `${adminApp}/reports/assignments`,
          nav: true,
          routes: {
            personalizedLessonAssignments: {
              name: "Personalized Lesson Assignment",
              route: `${adminApp}/reports/assignments/personalized-lesson-assignments`,
            },
          },
        },
        // microRoles: { name: "Micro Roles", route: `${adminApp}/reports/micro_roles` },
        // missions: { name: "Missions", route: `${adminApp}/reports/missions` },
        // microAssignments: {
        //   name: "Micro Assignments",
        //   route: `${adminApp}/reports/micro_assignments`,
        // },
        assessments: {
          name: "Assessments",
          route: `${adminApp}/reports/assessments`,
          nav: true,
        },
        assessmentId: {
          name: "Assessment Report",
          route: `${adminApp}/reports/assessments/:id`,
          routes: {
            userId: {
              name: "User Report",
              route: `${adminApp}/reports/assessments/:id/users/:user_id`,
            },
          },
        },
      },
    },
    comms: {
      name: "Communications",
      route: `${adminApp}/comms`,
      nav: true,
      navGroup: true,
      routes: {
        email: { name: "Email", route: `${adminApp}/comms/email`, nav: true },
        notify: { name: "Bell Notifications", route: `${adminApp}/comms/notify`, nav: true },
        banner: { name: "Platform Banner", route: `${adminApp}/comms/banner`, nav: true },
      },
    },
    paths: {
      name: "Paths & Quests",
      route: `${adminApp}/paths`,
      nav: true,
      navGroup: true,
      routes: {
        recommended: {
          name: "Recommended Paths",
          route: `${adminApp}/paths/recommended`,
          nav: true,
        },
        custom: { name: "Custom Paths", route: `${adminApp}/paths/custom`, nav: true },
        quests: { name: "Quests", route: `${adminApp}/paths/quests`, nav: true },
        new: { name: "New Path", route: `${adminApp}/paths/new` },
        edit: { name: "Edit Path", route: `${adminApp}/paths/edit/:id` },
        detail: { name: "Path Detail", route: `${adminApp}/paths/:id` },
        detailBySource: { name: "Path Detail", route: `${adminApp}/paths/:source/:id` },
      },
    },
    assignments: {
      name: "Assignments",
      route: `${adminApp}/assign`,
      nav: true,
      routes: {
        id: { name: "Assignment", route: `${adminApp}/assign/:id` },
        new: { name: "New Assignment", route: `${adminApp}/assign/new` },
        personalizedLessonAssignment: {
          name: "Personalized Lesson Assignment",
          route: `${adminApp}/assignments/personalized-lesson-assignment`,
          routes: {
            edit: {
              name: "Edit Personalized Lesson Assignment",
              route: `${adminApp}/assignments/personalized-lesson-assignment/:uuid/edit`,
            },
          },
        },
      },
    },
    assessments: {
      name: "Assessments",
      route: `${adminApp}/assess`,
      nav: true,
      routes: {
        new: { name: "New Assessment", route: `${adminApp}/assess/new` },
        id: { name: "Assessment", route: `${adminApp}/assess/:id` },
        recommendedAssignment: {
          name: "Recommended Assignment",
          route: `${adminApp}/assess/recommend/:assessmentId`,
        },
      },
    },
    resources: { name: "Custom Resources", route: `${adminApp}/resources`, nav: true },
    champions: {
      name: "Activities",
      route: `${adminApp}/champions`,
      nav: true,
      navFeature: "champion_passport",
      navGroup: true,
      routes: {
        mentors: { name: "Mentors", route: `${adminApp}/champions/mentors` },
        evaluate: { name: "Evaluate", route: `${adminApp}/champions/evaluate` },
        activities: {
          name: "Activity Configuration",
          route: `${adminApp}/champions/activities`,
          nav: true,
        },
        mentorRequests: {
          name: "Mentor Requests",
          route: `${adminApp}/champions/mentor`,
          nav: true,
          routes: {
            detail: { name: "Mentor Request", route: `${adminApp}/champions/mentor/:id` },
          },
        },
        evaluateRequests: {
          name: "Evaluation Requests",
          route: `${adminApp}/champions/evaluate`,
          nav: true,
          routes: {
            detail: { name: "Evaluation Request", route: `${adminApp}/champions/evaluate/:id` },
          },
        },
      },
    },
    tournaments: {
      name: "Tournaments",
      route: `${adminApp}/tournaments`,
      nav: true,
      navFeature: "tournaments",
      routes: {
        new: { name: "New Tournament", route: `${adminApp}/tournaments/new` },
        id: { name: "Edit Tournament", route: `${adminApp}/tournaments/:tournamentId` },
        leaderboard: {
          name: "Tournament Leaderboard",
          route: `${adminApp}/tournaments/leaderboard/:id`,
        },
      },
    },
    users: {
      name: "Users",
      route: `${adminApp}/users`,
      nav: true,
      routes: {
        id: {
          name: "User",
          route: `${adminApp}/users/:user_id`,
          routes: {
            profile: { name: "Profile", route: `${adminApp}/users/:user_id/profile` },
            history: { name: "History", route: `${adminApp}/users/:user_id/history` },
            certificates: {
              name: "Certificates",
              route: `${adminApp}/users/:user_id/certificates`,
            },
          },
        },
      },
    },
    aspen: {
      name: "Aspen",
      route: `${adminApp}/aspen`,
      nav: true,
      navGroup: true,
      routes: {
        settings: { name: "Settings", route: `${adminApp}/aspen/settings`, nav: true },
        assist: { name: "Aspen Assist", route: `${adminApp}/aspen/assist`, nav: true },
        guardian: { name: "Aspen Guardian", route: `${adminApp}/aspen/guardian`, nav: true },
        adapt: { name: "Aspen Adapt", route: `${adminApp}/aspen/adapt`, nav: true },
      },
    },
    // rolesPreview: { name: "Roles Preview", route: `${adminApp}/roles_preview` },
    // roleNewCourse: { name: "New Course", route: `${adminApp}/roles/new-path` },
    settings: { name: "Settings", route: `${adminApp}/settings`, nav: true },
    connections: {
      name: "Connections",
      route: `${adminApp}/connections`,
      nav: true,
      routes: {
        sso: { name: "SSO", route: `${adminApp}/connections/sso` },
        loginSettings: {
          name: "Login Settings",
          route: `${adminApp}/connections/login-settings`,
        },
        scim: { name: "SCIM", route: `${adminApp}/connections/scim` },
        aspen: { name: "Aspen Integrations", route: `${adminApp}/connections/aspen` },
        mcp: { name: "MCP", route: `${adminApp}/connections/mcp` },
        reportingApi: { name: "Reporting API", route: `${adminApp}/connections/reporting-api` },
        xapi: { name: "xAPI / LRS", route: `${adminApp}/connections/xapi` },
        webhooks: { name: "Webhooks", route: `${adminApp}/connections/webhooks` },
        apiKeys: { name: "API Keys", route: `${adminApp}/connections/api-keys` },
      },
    },
    keyManagement: { name: "Key Management", route: `${adminApp}/key-management`, nav: true },
    levels: {
      name: "Levels",
      routes: {
        id: { name: "Level", route: `${adminApp}/levels/:id` },
      },
    },
    // virtualDojos: {
    //   name: "Virtual Dojos",
    //   routes: {
    //     new: { name: "New Dojo", route: `${adminApp}/virtual-dojos/new-dojo` },
    //   },
    // },
    // latestChanges: { name: "Latest Changes", route: `${adminApp}/latest_changes` },
    aiCenter: { name: "AI Safety Center", route: `${adminApp}/ai` },
  },
};

export const KaAppRoutes = {
  name: "Knowledge Assessments",
  route: `${kaApp}`,
  routes: {
    assignment: { name: "Assignment Landing", route: `${kaApp}/assignment/:assignmentId` },
    contentTestGround: {
      name: "Content QA",
      route: `${kaApp}/:pillar/:objective/:topic/:question/qa`,
    },
    demoLandingPage: { name: "Demo Landing", route: `${kaApp}/demo` },
    userInitiatedExam: {
      name: "User Initiated Exam",
      route: `${kaApp}/assess/:section`,
    },
    examResult: {
      name: "Exam Result",
      route: `${kaApp}/result/:examInstanceId`,
    },
  },
};

export const LoginAppRoutes = {
  name: "Login",
  route: `${loginApp}`,
  routes: {
    // Unauthed pages
    forgotPassword: { name: "Forgot Password", route: `${loginApp}/forgot-password` },
    register: { name: "Register", route: `${loginApp}/register` },
    samlRedirect: { name: "SAML Redirect", route: `${loginApp}/saml` },
    signedOut: { name: "Signed Out", route: `${loginApp}/signed-out` },
    sjAdmin: { name: "SJ Admin Login", route: `${loginApp}/sj-admin` },
    verify: { name: "Verify Sign Up", route: `${loginApp}/verify` },
    scorm: { name: "SCORM Login", route: `${loginApp}/scorm/:idpId/lesson/:lessonKey` },
    demoRegister: { name: "Demo Register", route: `${loginApp}/demo-register` },
    mcpLogin: { name: "MCP Login", route: `${loginApp}/mcp` },

    // Authed pages
    tenantSelection: { name: "Tenant Selection", route: `${loginApp}/select-tenant` },
    unlicensed: { name: "Unlicensed", route: `${loginApp}/unlicensed` },
    developerProfile: { name: "Developer Profile", route: `${loginApp}/developer-profile` },

    // For now, sj-admin tenant list goes in the /login app
    tenantList: { name: "Tenant List", route: `${loginApp}/tenants` },
  },
};

export const ChampionsAppRoutes = {
  name: "Champions",
  route: `/champions`,
  routes: {
    activity: { name: "Activity Detail", route: `/champions/activity/:activityId` },
  },
};

export const sjAdminApp = "/sj-admin";

export const SjAdminAppRoutes = {
  name: "SJ Admin",
  route: sjAdminApp,
  routes: {
    dashboard: { name: "Dashboard", route: `${sjAdminApp}/dashboard` },
    aspen: { name: "Aspen", route: `${sjAdminApp}/aspen` },
    tenants: {
      name: "Tenants",
      route: `${sjAdminApp}/tenants`,
      routes: {
        new: { name: "New Tenant", route: `${sjAdminApp}/tenants/new` },
        detail: { name: "Tenant Detail", route: `${sjAdminApp}/tenants/:tenantId` },
        edit: { name: "Edit Tenant", route: `${sjAdminApp}/tenants/:tenantId/edit` },
      },
    },
    idps: {
      name: "IDPs",
      route: `${sjAdminApp}/idps`,
      routes: {
        detail: { name: "IDP Detail", route: `${sjAdminApp}/idps/:idpId` },
      },
    },
    submissions: {
      name: "Submissions",
      route: `${sjAdminApp}/submissions`,
      routes: {
        list: { name: "Submissions List", route: `${sjAdminApp}/submissions/:email` },
        detail: {
          name: "Submission Detail",
          route: `${sjAdminApp}/submissions/:email/:runId`,
        },
      },
    },
    promptAnalyzer: {
      name: "Prompt Analyzer",
      route: `${sjAdminApp}/prompt-analyzer`,
    },
  },
};

export const INTERNAL_ROUTES = {
  User: UserAppRoutes,
  Learn: LearnAppRoutes,
  Admin: AdminAppRoutes,
  Ka: KaAppRoutes,
  Login: LoginAppRoutes,
  Champions: ChampionsAppRoutes,
  SjAdmin: SjAdminAppRoutes,
};

export const EXTERNAL_ROUTES = {
  knowledgeBase: "https://help.securityjourney.com/",
  hackEdu: "https://app.hackedu.com/",
  privacy: "https://www.securityjourney.com/privacy",
  terms: "https://www.securityjourney.com/terms-of-service",
};

export const findRouteApp = (relativeUrl: string): string | null => {
  // Remove query string and hash if present
  const cleanUrl = relativeUrl.split("?")[0]?.split("#")[0] ?? relativeUrl;

  // Check all apps except Learn first (since Learn is mounted at "/" and would match everything)
  for (const [appName, appRoutes] of Object.entries(INTERNAL_ROUTES)) {
    if (appName === "Learn") continue;

    const baseRoute = appRoutes.route;
    // Match exact route or routes that start with the base path followed by /
    if (cleanUrl === baseRoute || cleanUrl.startsWith(`${baseRoute}/`)) {
      return appName;
    }
  }

  // If no other app matches, assume it belongs to Learn
  return "Learn";
};

export const buildRoute = (
  full_route_or_name: string,
  params: Record<string, string> = {},
  queryParams: Record<string, string | undefined> = {}
): string => {
  // Walk a dotted route name (e.g. "Learn.routes.lesson.route") through the nested
  // INTERNAL_ROUTES tree; each hop narrows an unknown until the final route string.
  // Fall back to the raw input if the path doesn't resolve to a string.
  const resolved: unknown = full_route_or_name.includes(".")
    ? full_route_or_name
        .split(".")
        .reduce<unknown>(
          (obj, key) =>
            typeof obj === "object" && obj !== null
              ? (obj as Record<string, unknown>)[key]
              : undefined,
          INTERNAL_ROUTES
        )
    : full_route_or_name;

  let route = typeof resolved === "string" ? resolved : full_route_or_name;

  Object.entries(params).forEach(([paramKey, paramValue]) => {
    route = route.replace(`:${paramKey}`, paramValue);
  });

  // Handle wildcard routes
  if (route.endsWith("/*")) {
    const wildcardValue = params["*"];
    if (wildcardValue) {
      route = route.replace("/*", `/${wildcardValue}`);
    }
  }

  const filteredQueryParams = Object.fromEntries(
    Object.entries(queryParams).filter(([_, value]) => value !== undefined)
  ) as Record<string, string>;
  const queryString = new URLSearchParams(filteredQueryParams).toString();
  return queryString ? `${route}?${queryString}` : route;
};

// Admin API
export const API_ADMINS_PATH = `${API}/admins`;

// Users API
export const API_EXPORT_USERS_PATH = `${API}/users/export`;
export const API_IMPORT_USERS_PATH = `${API}/users/import`;
export const API_USERS_PATH = `${API}/users`;
export const API_LICENSES_PATH = `${API_USERS_PATH}/licenses`;
export const API_SEARCH_USERS_PATH = `${API}/users/search`;
export const API_CSV_IMPORT_USERS_PATH = `${API_V2}/upload-users`;
export const API_USER_ACTIVITIES_PATH = "/api/internal_api/v1/current_user/activities";
export const apiArchiveUserPath = (id: string) => `${API}/users/${id}/archive`;
export const apiUnlockUserPath = (id: string) => `${API}/users/${id}/unlock`;
export const apiUserExtendTrialPath = (id: string) => `${API}/users/${id}/extend_trial`;
export const apiUserPath = (id: string) => `${API}/users/${id}`;
export const apiUserImpersonatePath = (id: string) => `${API}/users/${id}/impersonate`;
export const apiUserGenerateConfirmTokenPath = (id: string) =>
  `${API}/users/${id}/generate_confirm_token`;
export const apiUserGenerateResetTokenPath = (id: string) =>
  `${API}/users/${id}/generate_reset_token`;
export const apiUpdateUserPath = (id: string) => `${API}/users/${id}`;
export const apiAddLicenseToUserPath = (id: string) => `${API}/users/${id}/add_license`;
export const apiUserLocked = (id: string) => `${API}/users/${id}/check_locked_status`;

// Roles API
export const API_ROLES_PATH = `${API}/roles`;
export const apiRestrictRolePath = (id: string) => `${API}/roles/${id}`;

// Assignments API
export const API_ASSIGNMENT_POLICIES_PATH = `${API}/assignment_policies`;
export const apiAssignmentPath = (id: string) => `${API}/assignment_policies/${id}/assignments`;
